import PropTypes from 'prop-types';
import React, {Suspense} from 'react';
import {connect} from 'react-redux';
import UploadDialog from '@components/uploader/UploadDialog.jsx';
import {hideModal} from '@src/actions/ui.ts';
import {MODALS} from '@src/constants';
import lazyRetry from '@src/utils/lazyRetry.ts';

const ApiDialog = lazyRetry(() => import('./api-dialog/ApiDialog.jsx'));
const ExplorerDateRangeDialog = lazyRetry(
  () => import('./date-range-dialog/ExplorerDateRangeDialog.jsx'),
);
const SaveSearchDialog = lazyRetry(() => import('./SaveSearchDialog.jsx'));
const ShareDialog = lazyRetry(() => import('./share.jsx'));
const OrdersDialog = lazyRetry(
  () => import('./orders-dialog/ConnectedOrdersDialog.jsx'),
);

const ModalsManager = props => {
  let activeModal;

  const closeModal = () => {
    props.hideModal();
  };

  switch (props.modal) {
    case MODALS.DATE_RANGE:
      activeModal = <ExplorerDateRangeDialog onClose={closeModal} />;
      break;
    case MODALS.SAVE_SEARCH:
      activeModal = <SaveSearchDialog onClose={closeModal} />;
      break;
    case MODALS.API:
      activeModal = <ApiDialog onClose={closeModal} />;
      break;
    case MODALS.ORDER:
      activeModal = <OrdersDialog onClose={closeModal} />;
      break;
    case MODALS.SHARE:
      activeModal = <ShareDialog onClose={closeModal} />;
      break;
    case MODALS.UPLOAD:
      activeModal = <UploadDialog onClose={closeModal} />;
      break;
    default:
      activeModal = null;
  }

  return <Suspense>{activeModal}</Suspense>;
};

ModalsManager.propTypes = {
  hideModal: PropTypes.func.isRequired,
  modal: PropTypes.string,
};

const mapStateToProps = state => ({
  modal: state.ui.modal,
});

const mapDispatchProps = {
  hideModal,
};

export default connect(mapStateToProps, mapDispatchProps)(ModalsManager);
